import { DropdownType } from '../subcomponents/dropdown';
export const defaultQuickNavigatorDropdownSelectionsState = {
    [DropdownType.Site]: undefined,
    [DropdownType.Film]: undefined,
    [DropdownType.ScreeningDate]: undefined,
    [DropdownType.Showtime]: undefined
};
export const defaultQuickNavigatorState = {
    dropdownSelections: defaultQuickNavigatorDropdownSelectionsState,
    isExpanded: false,
    showModal: false,
    isMobile: false
};
